import { Skeleton, styled } from "@mui/material"
import { Fragment, useState } from "react"

const Image = styled("img")(() => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
}))
function SkeletonImage({ src, sx = {} }) {
  const [active, setActive] = useState(false)

  return (
    <Fragment>
      {!active &&
        <Skeleton
          sx={{
            width: "100%",
            height: "100%",
            transform: "none",
          }}
        />
      }
      <Image
        alt="img"
        src={src}
        sx={{
          display: active ? "block" : "none",
          ...sx
        }}
        onLoad={() => { setActive(true) }}
      />
    </Fragment>
  )
}

export default SkeletonImage